import ResourceStore from "../../../shared/services/ResourceStore";

class SequenceNumberStore extends ResourceStore {
  _baseUrl (_params) {
    return `/api/v4/companies/${_params.companyId}`;
  }
};

export default new SequenceNumberStore("sequence_number");
